import { render, staticRenderFns } from "./moduleContainer.vue?vue&type=template&id=5ae0a085&lang=html&"
import script from "./moduleContainer.vue?vue&type=script&lang=js&"
export * from "./moduleContainer.vue?vue&type=script&lang=js&"
import style0 from "./moduleContainer.vue?vue&type=style&index=0&id=5ae0a085&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports